import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePCountry, PCountry } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<PCountry>
      useData={usePCountry}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
